const PENDING_VERIFICATION_EMAIL_KEY = '__qc_pending_verification_email';

let mirroredEmail: string | null = null;
let mirroredEmailIsAuthoritative = false;

const removeStoredPendingVerificationEmail = (): void => {
  try {
    sessionStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
  } catch {
    // Browser storage may be blocked.
  }
};

export const setPendingVerificationEmail = (email: string): void => {
  mirroredEmail = email;
  mirroredEmailIsAuthoritative = true;
  try {
    sessionStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, email);
  } catch {
    removeStoredPendingVerificationEmail();
    // Keep the resend available in this document when browser storage is blocked.
  }
};

export const getPendingVerificationEmail = (): string | null => {
  if (mirroredEmailIsAuthoritative) {
    return mirroredEmail;
  }
  try {
    return sessionStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY) ?? mirroredEmail;
  } catch {
    return mirroredEmail;
  }
};

export const clearPendingVerificationEmail = (): void => {
  mirroredEmail = null;
  mirroredEmailIsAuthoritative = true;
  removeStoredPendingVerificationEmail();
};

export const consumePendingVerificationEmailFromUrl = (): void => {
  const url = new URL(window.location.href);
  if (url.pathname !== '/register/verify' || !url.searchParams.has('user_email')) {
    return;
  }

  const email = url.searchParams.get('user_email');
  if (email) {
    setPendingVerificationEmail(email);
  } else {
    clearPendingVerificationEmail();
  }

  url.searchParams.delete('user_email');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
};

export const clearPendingVerificationEmailOnActivation = (): void => {
  if (new URLSearchParams(window.location.search).get('account_activated') === '1') {
    clearPendingVerificationEmail();
  }
};
